import React, { useEffect, useState } from 'react'
import { CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { NineDay, Save, SixDay, ThreeDay, } from '../../../Constant';
import { Btn } from '../../../AbstractElements';
import { useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getRewardRate, getRewardRateRole, postRewardRate, postRewardRateRole } from '../../../CommonUrl';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';

const WebForm = () => {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const isReadOnly = authState.userRole !== 1;

    useEffect(() => {
        getDeliveryData();
    }, []);

    const getDeliveryData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRewardRate : getRewardRateRole);
        if (data.status === true) {
            const customerAppArray = data?.data;
            customerAppArray.map((e) => {
                if (e.type === 'customer_web') {
                    setValue('webThree', e?.thirty);
                    setValue('webSix', e?.sixty);
                    setValue('webNine', e?.ninety);
                }
            })
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }


    const onSubmit = async (data) => {
        setLoading(true);
        const customerApp = [
            {
                type: 'customer_web',
                thirty: data?.webThree,
                sixty: data?.webSix,
                ninety: data?.webNine
            }
        ];
        const postRequest = {
            reward_percentage: customerApp
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? postRewardRate : postRewardRateRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                getDeliveryData();
                toast.success(addAreaResponse.data.message);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <CardBody>
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="webThree">{ThreeDay}</Label>
                        <input className="form-control" id="webThree" type="text" readOnly={isReadOnly}
                            {...register('webThree')}
                        />
                    </Col>
                    <Col md='6'>
                        <Label className="form-label" for="webSix">{SixDay}</Label>
                        <input className="form-control" id="webSix" type="text" readOnly={isReadOnly}
                            {...register('webSix')}
                        />
                    </Col>
                </Row>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="webNine">{NineDay}</Label>
                        <input className="form-control" id="webNine" type="number" min="0" readOnly={isReadOnly}
                            {...register('webNine')}
                        />
                    </Col>
                </Row>
                <FormGroup>
                </FormGroup>
                <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
            </Form>
        </CardBody>

    )
}

export default WebForm